import { gql } from '../../../apollo/__generated__';

export const DELETE_IMAGE = gql(`
  mutation DeleteImage($id: ID!) {
    deleteImage(id: $id) {
      id
    }
  }
`);
